const createHtmlNode = (
  rootNode = "body",
  type = "div",
  classNames = [],
  text = "",
  attributes = {}
) => {
  const node = document.createElement(type);
  node.classList.add(classNames.join(" "));
  if (attributes) {
    for (let [key, value] of Object.entries(attributes)) {
      node.setAttribute(key, value);
    }
  }
  node.innerHTML = text;
  document.querySelector(rootNode).appendChild(node);
};

const setAttr = (el, attrs = {}) => {
  for (let key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

export { createHtmlNode, setAttr };
